import React from 'react';
import { MessageBar, MessageBarType } from '@fluentui/react';
import AssetsTable from '../../../../components/Storefront/Assets/AssetsTable';
import useCan, { STOREFRONT_ADMIN } from '../../../../permissions/ability';

// Org-wide storefront image library. Scoped assets (per storefront) are managed from the same table
// — the scope column tells them apart — but new uploads made here default to `global`.
const StorefrontAssetsPage: React.FC = () => {
    const canStorefrontAdmin = useCan(STOREFRONT_ADMIN);

    if (!canStorefrontAdmin) {
        return (
            <MessageBar messageBarType={MessageBarType.warning}>
                You do not have permission to manage storefront assets.
            </MessageBar>
        );
    }

    return (
        <div>
            <h1>Assets</h1>
            <AssetsTable />
        </div>
    );
};

export default StorefrontAssetsPage;
